import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { UserReferrer } from 'models';

import { useActiveEvents } from 'hooks/use-active-events';
import { useEvents } from 'hooks/use-events';
import { useLocalEvent } from 'hooks/use-local-event';

const useSetActiveEventOnMount = () => {
    const { localEvent, setLocalEvent } = useLocalEvent();
    const { events } = useActiveEvents();
    const { events: allEvents } = useEvents();

    const { query } = useRouter();

    const hasAutoSetRef = useRef(false);

    // only look at the referrer from the URL query params
    // not from the local storage/user object
    const referrer = query.referrer as UserReferrer | undefined;

    useEffect(() => {
        if (localEvent) return;
        if (!events.length) return;
        if (!allEvents.length) return;
        if (hasAutoSetRef.current) return;
        if (referrer !== UserReferrer.REPLUS) return;

        const now = Date.now();

        const nextFutureEvent = events
            .filter((event) => new Date(event.end).getTime() >= now)
            .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
            .at(0);

        if (nextFutureEvent) {
            setLocalEvent(nextFutureEvent.id);
            hasAutoSetRef.current = true;
        }
    }, [events, allEvents, referrer, localEvent]);
};

export { useSetActiveEventOnMount };
